import React from 'react';
import { ComponentLibraryLoader } from '@unite-us/app-components';
import { datadogRum } from '@datadog/browser-rum';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { hint2602ShowProviderOnboarding as hint2602ShowProviderOnboardingSelector } from 'common/utils/FeatureFlags/flags';
import { browserHistory } from 'common/utils/browserHistory';
import { env } from 'src/config/env';

const AppPO = ComponentLibraryLoader({
  loadFn: () => import('@unite-us/app-provider-onboarding'),
  component: 'AppProviderOnboarding',
  loadingApp: 'app-client',
  source: 'app-provider-onboarding',
  datadogRum,
});

const getBasename = ({ pathname, route, basename = '' }) => {
  const path = pathname.split(route).at(0);
  return `${basename}${path}${route}`;
};

const ProviderOnboarding = ({ hint2602ShowProviderOnboarding }) => {
  if (!hint2602ShowProviderOnboarding) {
    browserHistory.push('/');
    setTimeout(() => {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }, []);
    return null;
  }

  const basename = getBasename({
    // eslint-disable-next-line no-restricted-globals
    basename: location.basename,
    // eslint-disable-next-line no-restricted-globals
    pathname: location.pathname,
    route: 'onboarding',
  });

  return (
    <AppPO
      basename={basename}
      appSettings={{
        env: {
          GOOGLE_MAPS_API_KEY: env.GOOGLE_MAPS_API_KEY,
          PROVIDER_ONBOARDING_API_URL: 'https://provider-onboarding-api.uniteusdev.com',
        },
      }}
    />
  );
};

ProviderOnboarding.propTypes = {
  hint2602ShowProviderOnboarding: PropTypes.bool,
};

ProviderOnboarding.defaultProps = {
  hint2602ShowProviderOnboarding: false,
};

function mapStateToProps(state) {
  return {
    hint2602ShowProviderOnboarding: hint2602ShowProviderOnboardingSelector(state),
  };
}

export default connect(mapStateToProps)(ProviderOnboarding);
